import {css} from "@emotion/react";
import React, {useState} from 'react';
import {Grid} from "../../../Grid";
import {C800CallLogsContext} from "../800CallLogsProvider";
import {ByStateCallsCard} from "../ByStateCallsCard";

export const CallsByState: React.FC = () => {

    const {nCallsByState} = React.useContext(C800CallLogsContext);

    const othersCalls = React.useMemo(() => {
        return Object.entries(nCallsByState).filter(x => !["Virginia", "Ohio", "Pennsylvania"]
            .includes(x[0])).reduce((acc, curr) => {
            return acc + curr[1];
        }, 0);
    }, [nCallsByState]);
    return (

        <Grid contentCss={css({gridAutoRows: "1fr"})} lsize={"1fr"} rsize={"1fr"}>
            <ByStateCallsCard  variant={"blue"} state={"Virginia"} calls={nCallsByState["Virginia"] || 0}/>
            <ByStateCallsCard  variant={"yellow-green"} state={"Ohio"} calls={nCallsByState["Ohio"] || 0} />
            <ByStateCallsCard  variant={"green"} state={"Pennsylvania"} calls={nCallsByState["Pennsylvania"] || 0} />
            <ByStateCallsCard  variant={"orange"} state={"Others"} calls={othersCalls} />
        </Grid>
    );
};
